<template>
  <el-menu
    default-active="/solution"
    class="el-menu-vertical-demo"
    @open="handleOpen"
    @close="handleClose"
    :collapse="collapse"
    router
  >
    <template v-for="(item, index) in $router.options.routes">
      <template v-if="item.showChildren">
        <el-sub-menu :index="index + ''" :key="item.path" v-if="!item.hidden">
          <template #title>
            <el-icon>
              <component :is="item.icon" />
            </el-icon>
            <span>{{ item.name }}</span>
          </template>

          <template v-for="subItem in item.children">
            <el-menu-item
              v-if="!subItem.hidden"
              :index="item.path + subItem.path"
              :key="subItem.path"
            >
              <el-icon>
                <component :is="subItem.icon" />
              </el-icon>
              <span>{{ subItem.name }}</span></el-menu-item
            >
          </template>
        </el-sub-menu>
      </template>
      <template v-if="!item.showChildren">
        <el-menu-item v-if="!item.hidden" :index="item.path" :key="item.path">
          <el-icon>
            <component :is="item.icon" />
          </el-icon>
          <span>{{ item.name }}</span></el-menu-item
        >
      </template>
    </template>
  </el-menu>
</template>


<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 208px;
  min-height: calc(100vh);
}
.el-menu-vertical-demo:not(.el-menu--expand) {
  min-height: calc(100vh);
}
</style>

<script>
export default {
  name: "AsideBar",
  props: ["collapse"],
  setup() {
    function handleOpen(key, keyPath) {
      console.log(key, keyPath);
    }
    function handleClose(key, keyPath) {
      console.log(key, keyPath);
    }

    return {
      handleOpen,
      handleClose,
    };
  },
};
</script>
